module.exports = __webpack_public_path__ + "img/02028AZE.6c0e22ae.png";